export default "__VITE_ASSET__MCt6KiKA__"